
import React, { useState, useEffect } from 'react';

interface RotatingTextProps {
  words: string[];
  interval?: number;
  className?: string;
}

const RotatingText: React.FC<RotatingTextProps> = ({ 
  words, 
  interval = 2000, // Changed from 3000 to 2000 to rotate faster
  className = "" 
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [animationState, setAnimationState] = useState<'entering' | 'visible' | 'exiting'>('visible');

  useEffect(() => {
    const animationTimer = setInterval(() => {
      // Start exit animation
      setAnimationState('exiting');
      
      // After exit animation completes, change word and start enter animation
      setTimeout(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % words.length);
        setAnimationState('entering');
        
        // After enter animation completes, set to visible
        setTimeout(() => {
          setAnimationState('visible');
        }, 400); // Reduced from 500 to 400 for faster animation
      }, 400); // Reduced from 500 to 400 for faster animation
    }, interval);

    return () => clearInterval(animationTimer);
  }, [words, interval]);

  const getAnimationClass = () => {
    switch (animationState) {
      case 'entering':
        return 'opacity-0 animate-[fadeIn_500ms_ease_forwards] scale-95 animate-[scaleIn_500ms_ease_forwards]';
      case 'exiting':
        return 'opacity-100 animate-[fadeOut_400ms_ease_forwards] scale-100 animate-[scaleOut_400ms_ease_forwards]';
      default:
        return 'opacity-100 scale-100';
    }
  };

  // Different colors for each word
  const getWordColor = () => {
    const colors = [
      "text-blue-400", // Technology - blue
      "text-emerald-400", // Growth - green
      "text-amber-400" // Capital - amber/gold
    ];
    return colors[currentIndex % colors.length];
  };

  return (
    <span className={`inline-block transition-all duration-300 font-cursive italic ${getAnimationClass()} ${getWordColor()} ${className}`}>
      {words[currentIndex]}
    </span>
  );
};

export default RotatingText;
